module.exports = __webpack_public_path__ + "static/media/icons8-flag-filled.ae94c3e5.svg";